export default __webpack_public_path__ + "static/media/invoice.60a89613.svg";